<template>
  <img class="logo-img" v-if="imgSrc" :src="imgSrc" :alt="topicName" />
</template>

<script>
import lodashGet from "lodash/get";
import {
  findTopic,
  determinePrimaryTopics,
  getTopicIcon,
  getAllPrimaryTopics,
} from "@/services/events/topics.service";

export default {
  name: "TopicIcon",
  data: function () {
    const primaryTopics = [];
    let PRIMARY_TOPICS = getAllPrimaryTopics();
    for (let i = 0; i < PRIMARY_TOPICS.length; i++) {
      primaryTopics.push(PRIMARY_TOPICS[i].type);
    }
    return {
      topicName: null,
      imgSrc: null,
      acceptablePrimaryTopics: primaryTopics,
    };
  },
  props: {
    feature: {
      type: Object,
    },
  },
  mounted() {
    let topicScores = lodashGet(
      this.feature,
      "properties.formatted.topic_scores"
    );
    let isTwitter =
      lodashGet(this.feature, "properties.formatted.type") === "twitter";
    let primaryTopics = determinePrimaryTopics(
      topicScores,
      isTwitter,
      this.acceptablePrimaryTopics
    );
    if (primaryTopics && primaryTopics.length > 0) {
      let topic = findTopic(primaryTopics[0], true, false);
      this.imgSrc = getTopicIcon(topic.type, "plain");
    }
  },
};
</script>

<style scoped>
.logo-img {
  filter: invert(1);
}
</style>
